import en from "./en"

type Keys = keyof typeof en

export const dict = {
  "desktop.menu.app": "OpenCode",
  "desktop.menu.file": "文件",
  "desktop.menu.edit": "编辑",
  "desktop.menu.view": "视图",
  "desktop.menu.go": "转到",
  "desktop.menu.window": "窗口",
  "desktop.menu.help": "帮助",
  "desktop.menu.settings": "设置",
  "desktop.menu.reloadWebview": "重新加载 Webview",
  "desktop.menu.restart": "重启",
  "desktop.menu.exportLogs": "导出日志…",
  "desktop.menu.newSession": "新建会话",
  "desktop.menu.openProject": "打开项目…",
  "desktop.menu.newWindow": "新建窗口",
  "desktop.menu.closeWindow": "关闭窗口",
  "desktop.menu.undo": "撤销",
  "desktop.menu.redo": "重做",
  "desktop.menu.cut": "剪切",
  "desktop.menu.copy": "复制",
  "desktop.menu.paste": "粘贴",
  "desktop.menu.delete": "删除",
  "desktop.menu.selectAll": "全选",
  "desktop.menu.toggleSidebar": "切换侧边栏",
  "desktop.menu.toggleTerminal": "切换终端",
  "desktop.menu.toggleFileTree": "切换文件树",
  "desktop.menu.reload": "重新加载",
  "desktop.menu.toggleDeveloperTools": "切换开发人员工具",
  "desktop.menu.actualSize": "实际大小",
  "desktop.menu.zoomIn": "放大",
  "desktop.menu.zoomOut": "缩小",
  "desktop.menu.toggleFullScreen": "切换全屏显示",
  "desktop.menu.back": "后退",
  "desktop.menu.forward": "前进",
  "desktop.menu.previousSession": "上一个会话",
  "desktop.menu.nextSession": "下一个会话",
  "desktop.menu.previousProject": "上一个项目",
  "desktop.menu.nextProject": "下一个项目",
  "desktop.menu.minimize": "最小化",
  "desktop.menu.maximize": "最大化",
  "desktop.menu.documentation": "OpenCode 文档",
  "desktop.menu.supportForum": "支持论坛",
  "desktop.menu.shareFeedback": "提供反馈",
  "desktop.menu.reportBug": "报告错误",
  "desktop.menu.ariaLabel": "OpenCode 菜单",

  "desktop.recovery.action.relaunch": "重新启动",
  "desktop.recovery.action.exportLogs": "导出日志",
  "desktop.recovery.action.keepWaiting": "继续等待",
  "desktop.recovery.action.quit": "退出",
  "desktop.recovery.loadFailed": "OpenCode 加载失败",
  "desktop.recovery.terminated": "OpenCode 窗口意外终止",
  "desktop.recovery.unresponsive": "OpenCode 未响应",
  "desktop.recovery.unresponsive.detail": "你可以重新启动应用、打开日志或继续等待。",
  "desktop.recovery.loadFailed.detail": "窗口：{{window}}\nURL：{{url}}\n错误：{{code}} {{description}}",
  "desktop.recovery.terminated.detail": "窗口：{{window}}\n原因：{{reason}}\n代码：{{code}}",
  "desktop.recovery.unknown": "<未知>",

  "desktop.dialog.chooseFolder": "选择文件夹",
  "desktop.dialog.chooseFile": "选择文件",
  "desktop.dialog.saveFile": "保存文件",
  "desktop.dialog.files": "文件",
  "desktop.server.local": "本地服务器",

  "desktop.picker.error.notSelected": "文件选择器未选择文件",
  "desktop.picker.error.sizeLimit": "所选附件超过 {{limit}} MB 的限制",

  "command.category.suggested": "建议",
  "command.category.view": "视图",
  "command.category.project": "项目",
  "command.category.provider": "提供商",
  "command.category.server": "服务器",
  "command.category.session": "会话",
  "command.category.file": "文件",
  "command.category.context": "上下文",
  "command.category.model": "模型",
  "command.category.mcp": "MCP",
  "command.category.agent": "智能体",
  "command.category.permissions": "权限",
  "command.category.workspace": "工作区",
  "command.category.settings": "设置",
  "command.logs.export": "导出日志",

  "theme.scheme.system": "系统",
  "theme.scheme.light": "浅色",
  "theme.scheme.dark": "深色",

  "command.project.open": "打开项目",

  "command.provider.connect": "连接提供商",

  "command.settings.open": "打开设置",

  "command.session.location.cycle": "依次切换会话位置",

  "command.palette": "命令面板",

  "command.session.new": "新建会话",
  "command.session.import": "导入会话",

  "command.file.open": "打开文件",

  "command.tab.close": "关闭标签页",
  "command.tab.reopenClosed": "重新打开已关闭的标签页",

  "command.context.addSelection": "将所选内容添加到上下文",
  "command.context.addSelection.description": "添加当前文件中选中的行",

  "command.input.focus": "聚焦输入框",

  "command.fileTree.toggle": "切换文件树",

  "command.review.toggle": "切换审查",

  "command.message.previous": "上一条消息",
  "command.message.previous.description": "跳转到上一条用户消息",
  "command.message.next": "下一条消息",
  "command.message.next.description": "跳转到下一条用户消息",

  "command.model.choose": "选择模型",
  "command.model.choose.description": "选择不同的模型",

  "command.mcp.toggle": "启用或禁用 MCP 服务器",
  "command.mcp.toggle.description": "启用或禁用 MCP 服务器",

  "command.agent.cycle": "切换智能体",
  "command.agent.cycle.description": "切换到下一个智能体",
  "command.agent.cycle.reverse": "反向切换智能体",
  "command.agent.cycle.reverse.description": "切换到上一个智能体",

  "command.model.variant.cycle": "切换思考强度",
  "command.model.variant.cycle.description": "切换到下一个强度等级",

  "command.prompt.mode.shell": "Shell",
  "command.prompt.mode.normal": "Prompt",

  "command.permissions.autoaccept.enable": "自动接受权限",
  "command.permissions.autoaccept.disable": "停止自动接受权限",

  "command.session.undo": "撤销",
  "command.session.undo.description": "撤销上一条消息",
  "command.session.redo": "重做",
  "command.session.redo.description": "重做上一条撤销的消息",
  "command.session.compact": "压缩会话",
  "command.session.compact.description": "总结会话以减少上下文大小",
  "command.session.fork": "从消息创建新会话",
  "command.session.fork.description": "从之前的消息创建新会话",

  "command.session.export": "导出会话",
  "command.session.export.description": "将完整会话记录导出为 JSON",

  "palette.search.placeholder": "搜索文件、命令和会话",
  "palette.search.placeholder.home": "搜索命令和会话",
  "palette.empty": "未找到结果",
  "palette.group.commands": "命令",
  "palette.group.files": "文件",

  "dialog.provider.search.placeholder": "搜索提供商",
  "dialog.provider.empty": "未找到提供商",
  "dialog.provider.group.popular": "热门",
  "dialog.provider.group.other": "其他",
  "dialog.provider.custom.label": "自定义 OpenAI 兼容提供商",
  "dialog.provider.tag.recommended": "推荐",
  "dialog.provider.opencode.note": "精选模型，包括 Claude、GPT、Gemini 等",
  "dialog.provider.opencode.tagline": "可靠的优化模型",
  "dialog.provider.opencodeGo.tagline": "适合所有人的低成本订阅",
  "dialog.provider.anthropic.note": "通过 API 密钥直接使用 Claude 模型",
  "dialog.provider.copilot.note": "通过 GitHub Copilot 使用辅助编程 AI 模型",
  "dialog.provider.openai.note": "适合快速处理各类 AI 任务的 GPT 模型",
  "dialog.provider.google.note": "可快速生成结构化回复的 Gemini 模型",
  "dialog.provider.openrouter.note": "通过一个提供商使用所有受支持的模型",
  "dialog.provider.vercel.note": "通过智能路由统一使用 AI 模型",

  "dialog.model.select.title": "选择模型",
  "dialog.model.search.placeholder": "搜索模型",
  "dialog.model.empty": "未找到模型",
  "dialog.model.manage": "管理模型",
  "dialog.model.manage.description": "自定义模型选择器中显示的模型。",
  "dialog.model.unpaid.freeModels.title": "OpenCode 提供的免费模型",
  "dialog.model.unpaid.addMore.title": "从热门提供商添加更多模型",
  "dialog.model.unpaid.viewMoreProviders": "查看另外 70 多个提供商",

  "dialog.provider.viewAll": "查看更多提供商",

  "provider.connect.title": "连接 {{provider}}",
  "provider.connect.title.anthropicProMax": "登录 Anthropic",
  "provider.connect.selectMethod": "选择 {{provider}} 的登录方式。",
  "provider.connect.method.apiKey": "API 密钥",
  "provider.connect.method.browser": "浏览器",
  "provider.connect.method.headless": "无头模式",
  "provider.connect.status.inProgress": "正在授权…",
  "provider.connect.status.waiting": "等待授权…",
  "provider.connect.status.failed": "授权失败：{{error}}",
  "provider.connect.apiKey.description":
    "输入你的 {{provider}} API 密钥以连接账户，并在 OpenCode 中使用 {{provider}} 模型。",
  "provider.connect.apiKey.label": "{{provider}} API 密钥",
  "provider.connect.apiKey.placeholder": "API 密钥",
  "provider.connect.apiKey.required": "API 密钥为必填项",
  "provider.connect.oauth.code.label": "{{method}} 授权码",
  "provider.connect.oauth.code.placeholder": "授权码",
  "provider.connect.oauth.code.required": "授权码为必填项",
  "provider.connect.oauth.code.invalid": "授权码无效",
  "provider.connect.oauth.auto.confirmationCode": "确认码",
  "provider.connect.toast.connected.title": "{{provider}} 已连接",
  "provider.connect.toast.connected.description": "现在可以使用 {{provider}} 模型了。",

  "provider.custom.title": "自定义提供商",
  "provider.custom.unavailable": "此服务器上无法使用自定义提供商",
  "provider.custom.description.prefix": "配置与 OpenAI 兼容的提供商。请查看",
  "provider.custom.description.link": "提供商配置文档",
  "provider.custom.description.suffix": "。",
  "provider.custom.field.providerID.label": "提供商 ID",
  "provider.custom.field.providerID.placeholder": "myprovider",
  "provider.custom.field.providerID.description": "使用小写字母、数字、连字符或下划线",
  "provider.custom.field.name.label": "显示名称",
  "provider.custom.field.name.placeholder": "我的 AI 提供商",
  "provider.custom.field.baseURL.label": "基础 URL",
  "provider.custom.field.baseURL.placeholder": "https://api.myprovider.com/v1",
  "provider.custom.field.apiKey.label": "API 密钥",
  "provider.custom.field.apiKey.placeholder": "API 密钥",
  "provider.custom.field.apiKey.description": "可选。如果你通过请求头管理认证，可留空。",
  "provider.custom.models.label": "模型",
  "provider.custom.models.id.label": "ID",
  "provider.custom.models.id.placeholder": "model-id",
  "provider.custom.models.name.label": "名称",
  "provider.custom.models.name.placeholder": "显示名称",
  "provider.custom.models.remove": "移除模型",
  "provider.custom.models.add": "添加模型",
  "provider.custom.headers.label": "请求头（可选）",
  "provider.custom.headers.key.label": "请求头",
  "provider.custom.headers.key.placeholder": "Header-Name",
  "provider.custom.headers.value.label": "值",
  "provider.custom.headers.value.placeholder": "value",
  "provider.custom.headers.remove": "移除请求头",
  "provider.custom.headers.add": "添加请求头",
  "provider.custom.error.providerID.required": "提供商 ID 为必填项",
  "provider.custom.error.providerID.format": "请使用小写字母、数字、连字符或下划线",
  "provider.custom.error.providerID.exists": "该提供商 ID 已存在",
  "provider.custom.error.name.required": "显示名称为必填项",
  "provider.custom.error.baseURL.required": "基础 URL 为必填项",
  "provider.custom.error.baseURL.format": "必须以 http:// 或 https:// 开头",
  "provider.custom.error.required": "必填",
  "provider.custom.error.duplicate": "重复",

  "provider.disconnect.toast.disconnected.title": "{{provider}} 已断开连接",
  "provider.disconnect.toast.disconnected.description": "{{provider}} 模型已不再可用。",
  "provider.disconnect.toast.noCredentials.description": "未找到 {{provider}} 的可移除凭据。",
  "provider.disconnect.toast.failed.description": "无法断开 {{provider}} 连接。",

  "model.tag.free": "免费",
  "model.tag.latest": "最新",
  "model.provider.anthropic": "Anthropic",
  "model.provider.openai": "OpenAI",
  "model.provider.google": "Google",
  "model.provider.xai": "xAI",
  "model.provider.meta": "Meta",
  "model.input.text": "文本",
  "model.input.image": "图像",
  "model.input.audio": "音频",
  "model.input.video": "视频",
  "model.input.pdf": "PDF",
  "model.tooltip.allows": "支持：{{inputs}}",
  "model.tooltip.context.label": "上下文",
  "model.tooltip.inputs": "输入",
  "model.tooltip.model": "模型",
  "model.tooltip.provider": "提供商",
  "model.tooltip.reasoning": "推理",
  "model.tooltip.reasoning.allowed": "支持推理",
  "model.tooltip.reasoning.none": "不支持推理",
  "model.tooltip.context": "上下文上限 {{limit}}",

  "common.search.placeholder": "搜索",
  "common.goBack": "返回",
  "common.goForward": "前进",
  "common.loading": "加载中",
  "common.loading.ellipsis": "…",
  "common.cancel": "取消",
  "common.clear": "清除",
  "common.connect": "连接",
  "common.disconnect": "断开连接",
  "common.continue": "继续",
  "common.submit": "提交",
  "common.save": "保存",
  "common.saving": "保存中…",
  "common.default": "默认",
  "common.attachment": "附件",

  "prompt.placeholder.shell": "输入 shell 命令… {{example}}",
  "prompt.placeholder.normal": '随便问点什么… "{{example}}"',
  "prompt.mode.shell": "Shell",
  "prompt.mode.normal": "Prompt",
  "session.child.promptDisabled": "无法向子智能体会话发送提示词。",
  "session.child.backToParent": "返回主会话。",
  "prompt.action.attachFile": "附加文件",
  "prompt.toast.attachmentDuplicate.title": "此文件已上传",
  "prompt.toast.uploading.percent": "{{percent}}%",
  "prompt.toast.uploading.cancelFile": "取消上传 {{filename}}",
  "prompt.toast.uploadFailed.title": "上传失败",
  "prompt.toast.modelAgentRequired.title": "请选择智能体和模型",
  "prompt.toast.modelAgentRequired.description": "发送提示前请先选择智能体和模型。",
  "prompt.toast.worktreeCreateFailed.title": "创建工作区失败",
  "prompt.toast.sessionCreateFailed.title": "创建会话失败",
  "prompt.toast.shellSendFailed.title": "发送 shell 命令失败",
  "prompt.toast.commandSendFailed.title": "发送命令失败",
  "prompt.toast.promptSendFailed.title": "发送提示失败",

  "dialog.mcp.title": "MCP 服务器",
  "dialog.mcp.description": "已启用 {{enabled}} / {{total}}",
  "dialog.mcp.empty": "未配置 MCP 服务器",

  "mcp.status.connected": "已连接",
  "mcp.status.failed": "失败",
  "mcp.status.needs_auth": "需要授权",
  "mcp.status.disabled": "已禁用",

  "dialog.fork.empty": "没有可用于创建新会话的消息",

  "dialog.directory.action.selectFile": "选择文件",
  "dialog.directory.action.selectFolder": "选择文件夹",
  "dialog.directory.root": "根目录",
  "dialog.directory.parent": "上级目录",
  "dialog.directory.readError": "无法读取此文件夹",

  "dialog.server.add.title": "添加服务器",
  "dialog.server.add.url": "服务器 URL",
  "dialog.server.add.placeholder": "http://localhost:4096",
  "dialog.server.add.error": "无法连接到服务器",
  "dialog.server.add.checking": "检查中…",
  "dialog.server.add.button": "添加服务器",
  "dialog.server.add.name": "服务器名称（可选）",
  "dialog.server.add.namePlaceholder": "Localhost",
  "dialog.server.add.password": "密码（可选）",
  "dialog.server.edit.title": "编辑服务器",
  "dialog.server.menu.edit": "编辑",

  "dialog.project.edit.title": "编辑项目",
  "dialog.project.edit.icon": "图标",
  "dialog.project.edit.icon.alt": "项目图标",
  "dialog.project.edit.color": "颜色",
  "dialog.project.edit.color.select": "选择颜色：{{color}}",
  "dialog.project.edit.worktree.startup": "工作区启动脚本",
  "dialog.project.edit.worktree.startup.placeholder": "例如 bun install",

  "dialog.usageExceeded.dontShowAgain": "不再显示",

  "toast.permissions.autoaccept.on.title": "正在自动接受权限",
  "toast.permissions.autoaccept.on.description": "权限请求将被自动批准",
  "toast.permissions.autoaccept.off.title": "已停止自动接受权限",
  "toast.permissions.autoaccept.off.description": "权限请求将需要批准",
  "toast.file.loadFailed.title": "加载文件失败",
  "toast.file.listFailed.title": "列出文件失败",
  "toast.context.noLineSelection.title": "未选择行",
  "toast.context.noLineSelection.description": "请先在文件标签中选择行范围。",
  "toast.session.export.success.title": "会话已导出",
  "toast.session.export.success.description": "已将会话保存到 {{filename}}",
  "toast.session.export.failed.title": "导出会话失败",
  "toast.session.export.failed.description": "导出会话时发生错误",

  "error.page.title": "出了点问题",
  "error.page.description": "加载应用程序时发生错误。",
  "error.page.description.localServerStartup": "启动本地服务器时发生错误。",
  "error.page.details.label": "错误详情",
  "error.page.action.restart": "重启",
  "error.page.action.report": "上报错误",
  "error.page.action.reported": "错误已上报",
  "error.page.action.exportLogs": "导出日志",
  "error.page.action.checking": "检查中…",
  "error.page.action.checkUpdates": "检查更新",
  "error.page.action.updateTo": "更新到 {{version}}",
  "error.page.report.prefix": "请将此错误报告给 OpenCode 团队",
  "error.page.report.discord": "在 Discord 上",
  "error.page.version": "版本：{{version}}",
  "error.dev.rootNotFound": "未找到根元素。你是不是忘了把它添加到 index.html？或者 id 属性拼写错了？",
  "error.serverSync.connectFailed": "无法连接到服务器。是否有服务器正在 `{{url}}` 运行？",

  "error.chain.unknown": "未知错误",
  "error.chain.causedBy": "原因：",
  "error.chain.apiError": "API 错误",
  "error.chain.status": "状态：{{status}}",
  "error.chain.retryable": "可重试：{{retryable}}",
  "error.chain.responseBody": "响应内容：\n{{body}}",
  "error.chain.didYouMean": "你是不是想输入：{{suggestions}}",
  "error.chain.modelNotFound": "未找到模型：{{provider}}/{{model}}",
  "error.chain.checkConfig": "请检查你的配置 (opencode.json) 中的 provider/model 名称",
  "error.chain.mcpFailed": 'MCP 服务器 "{{name}}" 启动失败。注意：OpenCode 暂不支持 MCP 认证。',
  "error.chain.providerAuthFailed": "提供商认证失败（{{provider}}）：{{message}}",
  "error.chain.providerInitFailed": '无法初始化提供商 "{{provider}}"。请检查凭据和配置。',
  "error.chain.configJsonInvalid": "配置文件 {{path}} 不是有效的 JSON(C)",
  "error.chain.configJsonInvalidWithMessage": "配置文件 {{path}} 不是有效的 JSON(C)：{{message}}",
  "error.chain.configDirectoryTypo":
    '{{path}} 中的目录 "{{dir}}" 无效。请将目录重命名为 "{{suggestion}}" 或移除它。这是一个常见拼写错误。',
  "error.chain.configFrontmatterError": "无法解析 {{path}} 中的 frontmatter：\n{{message}}",
  "error.chain.configInvalid": "配置文件 {{path}} 无效",
  "error.chain.configInvalidWithMessage": "配置文件 {{path}} 无效：{{message}}",

  "notification.permission.title": "需要权限",
  "notification.session.responseReady.title": "回复已就绪",
  "notification.session.error.title": "会话错误",
  "notification.session.error.fallbackDescription": "发生错误",

  "home.title": "主页",
  "home.projects": "项目",
  "home.project.add": "添加项目",
  "home.recentlyClosed": "最近关闭",
  "home.server.collapse": "折叠服务器项目",
  "home.server.expand": "展开服务器项目",
  "home.sessions.search.placeholder": "搜索会话",
  "home.sessions.search.placeholder.scoped": "在 {{scope}} 中搜索会话",
  "home.sessions.search.sessions": "会话",
  "home.sessions.search.noResults": "未找到与 {{query}} 相关的会话",
  "home.sessions.empty": "这里还没有内容",
  "home.sessions.empty.description": "创建一个会话以开始。",
  "home.sessions.group.today": "今天",
  "home.sessions.group.yesterday": "昨天",
  "home.sessions.group.older": "更早",
  "home.providerTip": "连接 75 个以上的提供商，使用包括 Claude、GPT、Gemini 在内的更多模型",

  "session.tab.session": "会话",
  "session.tab.unknown": "未知会话",
  "session.panel.reviewAndFiles": "审查和文件",
  "session.error.notFound": "找不到此会话",
  "session.error.notFound.description": "此标签页指向的会话已不存在于此服务器上。",
  "session.error.notFound.closeTab": "关闭标签页",
  "session.files.selectToOpen": "选择要打开的文件",
  "session.messages.loading": "正在加载消息…",
  "session.messages.jumpToLatest": "跳转到最新",
  "session.question.minimize": "收起问题",
  "session.question.restore": "展开问题",
  "session.new.project.new": "新建项目",
  "session.new.project.search": "搜索项目",
  "session.new.project.add": "添加项目",
  "session.new.workspace.runIn": "运行会话的位置",
  "session.new.workspace.triggerLocal": "本地",
  "session.new.workspace.local": "本地仓库",
  "session.new.git.none": "无 Git",

  "settings.tab.servers": "服务器",
  "settings.extensions.tab.plugins": "插件",

  "common.copied": "已复制",

  "common.closeTab": "关闭标签页",
  "common.dismiss": "忽略",
  "common.requestFailed": "请求失败",
  "common.moreOptions": "更多选项",
  "common.learnMore": "了解更多",
  "common.rename": "重命名",
  "common.export": "导出",
  "common.reset": "重置",
  "common.archive": "归档",
  "common.delete": "删除",
  "common.close": "关闭",
  "common.edit": "编辑",
  "common.loadMore": "加载更多",
  "common.key.esc": "ESC",

  "sidebar.settings": "设置",
  "sidebar.help": "帮助",
  "sidebar.project.recentSessions": "最近会话",
  "sidebar.project.clearNotifications": "清除通知",

  "settings.section.server": "服务器",

  "settings.tab.shortcuts": "快捷键",

  "settings.general.section.appearance": "外观",
  "settings.general.section.notifications": "系统通知",
  "settings.general.section.sounds": "音效",
  "settings.general.row.language.title": "语言",
  "settings.general.row.language.description": "更改 OpenCode 的显示语言",
  "settings.general.row.shell.title": "终端 Shell",
  "settings.general.row.shell.description": "选择终端使用的 shell。兼容的 shell 也会用于智能体工具调用。",
  "settings.general.row.shell.autoDefault": "自动（默认）",
  "settings.general.row.shell.terminalOnly": "仅终端",
  "settings.general.row.colorScheme.title": "配色方案",
  "settings.general.row.colorScheme.description": "选择 OpenCode 跟随系统、浅色或深色主题",
  "settings.general.row.theme.title": "主题",
  "settings.general.row.theme.description": "自定义 OpenCode 的主题。",
  "settings.general.row.font.title": "代码字体",
  "settings.general.row.font.description": "自定义代码块使用的字体",
  "settings.general.row.terminalFont.title": "终端字体",
  "settings.general.row.terminalFont.description": "自定义终端使用的字体",
  "settings.general.row.uiFont.title": "界面字体",
  "settings.general.row.uiFont.description": "自定义整个界面使用的字体",
  "settings.general.row.mobileTitlebarBottom.title": "底部导航",
  "settings.general.row.mobileTitlebarBottom.description": "在移动设备上将标题栏和会话标签页置于屏幕底部",
  "settings.general.row.showCustomAgents.title": "显示智能体",
  "settings.general.row.showCustomAgents.description": "在输入框中切换智能体。隐藏时默认使用 Build 智能体。",
  "settings.general.row.pinchZoom.title": "双指缩放",
  "settings.general.row.pinchZoom.description": "允许使用触控板双指捏合和 Ctrl+滚轮手势缩放",

  "sound.option.none": "无",
  "sound.option.alert01": "警报 01",
  "sound.option.alert02": "警报 02",
  "sound.option.alert03": "警报 03",
  "sound.option.alert04": "警报 04",
  "sound.option.alert05": "警报 05",
  "sound.option.alert06": "警报 06",
  "sound.option.alert07": "警报 07",
  "sound.option.alert08": "警报 08",
  "sound.option.alert09": "警报 09",
  "sound.option.alert10": "警报 10",
  "sound.option.bipbop01": "Bip-bop 01",
  "sound.option.bipbop02": "Bip-bop 02",
  "sound.option.bipbop03": "Bip-bop 03",
  "sound.option.bipbop04": "Bip-bop 04",
  "sound.option.bipbop05": "Bip-bop 05",
  "sound.option.bipbop06": "Bip-bop 06",
  "sound.option.bipbop07": "Bip-bop 07",
  "sound.option.bipbop08": "Bip-bop 08",
  "sound.option.bipbop09": "Bip-bop 09",
  "sound.option.bipbop10": "Bip-bop 10",
  "sound.option.staplebops01": "Staplebops 01",
  "sound.option.staplebops02": "Staplebops 02",
  "sound.option.staplebops03": "Staplebops 03",
  "sound.option.staplebops04": "Staplebops 04",
  "sound.option.staplebops05": "Staplebops 05",
  "sound.option.staplebops06": "Staplebops 06",
  "sound.option.staplebops07": "Staplebops 07",
  "sound.option.nope01": "Nope 01",
  "sound.option.nope02": "Nope 02",
  "sound.option.nope03": "Nope 03",
  "sound.option.nope04": "Nope 04",
  "sound.option.nope05": "Nope 05",
  "sound.option.nope06": "Nope 06",
  "sound.option.nope07": "Nope 07",
  "sound.option.nope08": "Nope 08",
  "sound.option.nope09": "Nope 09",
  "sound.option.nope10": "Nope 10",
  "sound.option.nope11": "Nope 11",
  "sound.option.nope12": "Nope 12",
  "sound.option.yup01": "Yup 01",
  "sound.option.yup02": "Yup 02",
  "sound.option.yup03": "Yup 03",
  "sound.option.yup04": "Yup 04",
  "sound.option.yup05": "Yup 05",
  "sound.option.yup06": "Yup 06",

  "settings.general.notifications.agent.title": "智能体",
  "settings.general.notifications.agent.description": "当智能体完成或需要注意时显示系统通知",
  "settings.general.notifications.permissions.title": "权限",
  "settings.general.notifications.permissions.description": "当需要权限时显示系统通知",
  "settings.general.notifications.errors.title": "错误",
  "settings.general.notifications.errors.description": "发生错误时显示系统通知",
  "settings.general.sounds.agent.title": "智能体",
  "settings.general.sounds.agent.description": "当智能体完成或需要注意时播放声音",
  "settings.general.sounds.permissions.title": "权限",
  "settings.general.sounds.permissions.description": "当需要权限时播放声音",
  "settings.general.sounds.errors.title": "错误",
  "settings.general.sounds.errors.description": "发生错误时播放声音",

  "settings.shortcuts.title": "键盘快捷键",
  "settings.shortcuts.reset.button": "重置为默认值",
  "settings.shortcuts.reset.toast.title": "快捷键已重置",
  "settings.shortcuts.reset.toast.description": "键盘快捷键已重置为默认设置。",
  "settings.shortcuts.conflict.title": "快捷键已被占用",
  "settings.shortcuts.conflict.description": "{{keybind}} 已分配给 {{titles}}。",
  "settings.shortcuts.unassigned": "未设置",
  "settings.shortcuts.pressKeys": "按下按键",
  "settings.shortcuts.search.placeholder": "搜索快捷键",
  "settings.shortcuts.group.general": "通用",
  "settings.shortcuts.group.session": "会话",
  "settings.shortcuts.group.navigation": "导航",
  "settings.shortcuts.group.modelAndAgent": "模型与智能体",
  "settings.shortcuts.group.terminal": "终端",
  "settings.shortcuts.group.prompt": "提示",

  "settings.providers.title": "提供商",
  "settings.providers.description": "可在此处配置提供商设置。",
  "settings.providers.section.connected": "已连接的提供商",
  "settings.providers.connected.empty": "没有已连接的提供商",
  "settings.providers.section.popular": "热门提供商",
  "settings.providers.tag.environment": "环境",
  "settings.providers.tag.config": "配置",
  "settings.providers.tag.custom": "自定义",
  "settings.providers.tag.other": "其他",

  "settings.models.title": "模型",
  "settings.models.description": "可在此处配置模型设置。",

  "settings.permissions.tool.read.title": "读取",
  "settings.permissions.tool.read.description": "读取文件（匹配文件路径）",
  "settings.permissions.tool.edit.title": "编辑",
  "settings.permissions.tool.edit.description": "修改文件，包括编辑、写入和应用补丁",
  "settings.permissions.tool.glob.title": "Glob",
  "settings.permissions.tool.glob.description": "使用 glob 模式匹配文件",
  "settings.permissions.tool.grep.title": "Grep",
  "settings.permissions.tool.grep.description": "使用正则表达式搜索文件内容",
  "settings.permissions.tool.list.title": "列出文件",
  "settings.permissions.tool.list.description": "列出目录中的文件",
  "settings.permissions.tool.bash.title": "Bash",
  "settings.permissions.tool.bash.description": "运行 shell 命令",
  "settings.permissions.tool.task.title": "任务",
  "settings.permissions.tool.task.description": "启动子智能体",
  "settings.permissions.tool.skill.title": "技能",
  "settings.permissions.tool.skill.description": "按名称加载技能",
  "settings.permissions.tool.lsp.title": "LSP",
  "settings.permissions.tool.lsp.description": "运行语言服务器查询",
  "settings.permissions.tool.todowrite.title": "更新待办",
  "settings.permissions.tool.todowrite.description": "更新待办列表",
  "settings.permissions.tool.webfetch.title": "获取网页",
  "settings.permissions.tool.webfetch.description": "从 URL 获取内容",
  "settings.permissions.tool.websearch.title": "网页搜索",
  "settings.permissions.tool.websearch.description": "搜索网页",
  "settings.permissions.tool.external_directory.title": "外部目录",
  "settings.permissions.tool.external_directory.description": "访问项目目录之外的文件",
  "settings.permissions.tool.doom_loop.title": "死循环",
  "settings.permissions.tool.doom_loop.description": "检测具有相同输入的重复工具调用",

  "session.delete.failed.title": "删除会话失败",
  "session.delete.title": "删除会话",
  "session.delete.confirm": '删除会话 "{{name}}"？',
  "session.delete.button": "删除会话",

  "workspace.new": "新建工作区",
  "workspace.delete.failed.title": "删除工作区失败",
  "workspace.status.checking": "正在检查未合并的更改…",
  "workspace.status.error": "无法验证 Git 状态。",
  "workspace.status.dirty": "检测到未合并的更改。",
  "workspace.delete.button": "删除工作区",
  "common.open": "打开",
  "toast.project.reloadFailed.title": "无法重新加载 {{project}}",
  "error.server.invalidConfiguration": "配置无效",
  "common.moreCountSuffix": " (还有 {{count}} 个)",
  "common.time.justNow": "刚刚",
  "common.time.minutesAgo.short": "{{count}}分钟前",
  "common.time.hoursAgo.short": "{{count}}小时前",
  "common.time.daysAgo.short": "{{count}}天前",
  "settings.providers.connected.environmentDescription": "已通过环境变量连接",

  "dialog.server.add.passwordPlaceholder": "密码",
  "session.question.progress": "{{current}}/{{total}} 个问题",
  "session.header.open.finder": "访达",
  "session.header.open.fileExplorer": "文件资源管理器",
  "session.header.reveal.finder": "在访达中显示",
  "session.header.reveal.fileExplorer": "在文件资源管理器中显示",
  "session.header.reveal.containingFolder": "打开所在文件夹",
  "session.header.open.fileManager": "文件管理器",
  "common.key.ctrl": "Ctrl",
  "common.key.alt": "Alt",
  "common.key.shift": "Shift",
  "common.key.meta": "Meta",
  "common.key.space": "空格",
  "common.key.backspace": "退格",
  "common.key.enter": "回车",
  "common.key.tab": "Tab",
  "common.key.delete": "Delete",
  "common.key.home": "Home",
  "common.key.end": "End",
  "common.key.pageUp": "Page Up",
  "common.key.pageDown": "Page Down",
  "common.key.insert": "Insert",
  "common.unknown": "未知",
  "error.page.circular": "[循环]",
  "error.serverSDK.noServerAvailable": "无可用服务器",
  "error.serverSDK.serverNotAvailable": "服务器不可用",
  "error.childStore.persistedCacheCreateFailed": "创建持久化缓存失败",
  "error.childStore.persistedProjectMetadataCreateFailed": "创建持久化项目元数据失败",
  "error.childStore.persistedProjectIconCreateFailed": "创建持久化项目图标失败",
  "error.childStore.storeCreateFailed": "创建存储失败",
  "toast.migration.failed.title": "数据迁移失败",
  "command.session.background": "移至后台",
  "settings.tab.preferences": "偏好设置",
  "settings.tab.notifications": "通知",
  "settings.tab.projects": "项目",
  "settings.tab.extensions": "扩展",
  "settings.preferences.description": "自定义偏好、主题和默认行为",
  "settings.appearance.description": "自定义主题和字体",
  "settings.notifications.description": "选择接收通知和播放声音的时机",
  "settings.shortcuts.description": "自定义常用操作的快捷键",
  "settings.servers.description": "管理服务器连接",
  "settings.projects.title": "项目",
  "settings.projects.description": "管理此服务器上的项目设置",
  "settings.projects.empty": "未找到项目",
  "settings.extensions.description": "管理此服务器上可用的扩展",
  "settings.extensions.tab.mcps": "MCP",
  "settings.extensions.tab.skills": "技能",
  "settings.extensions.availableAll": "可用于所有项目",
  "settings.extensions.manageConfig": "在 opencode.json 中管理",
  "settings.extensions.addSkills": "如何添加技能",
  "project.settings.extensions.description": "查看此项目可用的扩展",
  "project.settings.extensions.tab.lsps": "LSP",
  "project.settings.extensions.added": "已添加到此项目",
  "project.settings.extensions.shared": "与所有项目共享",
  "project.settings.extensions.lsp.description": "根据文件类型自动检测",
  "settings.general.section.general": "常规",
  "common.viewAll": "查看全部",
  "session.new.workspace.local.tooltip": "使用当前检出",
  "session.new.workspace.new.tooltip": "创建隔离检出",
  "session.new.workspace.fromBranch": "基于 {{branch}}",
  "session.new.workspace.trigger.tooltip": "选择会话的运行位置",
  "session.new.workspace.search.placeholder": "搜索工作区",
  "settings.tab.workspaces": "工作区",
  "settings.workspaces.filter.all": "所有项目",
  "settings.workspaces.empty": "没有工作区",
  "settings.workspaces.count.one": "{{count}} 个工作区",
  "settings.workspaces.count.other": "{{count}} 个工作区",
  "settings.workspaces.sessions.one": "{{project}} 中有 {{count}} 个会话",
  "settings.workspaces.sessions.other": "{{project}} 中有 {{count}} 个会话",
  "settings.workspaces.lastActiveSession": "上次活跃的会话",
  "settings.workspaces.deleteAll": "删除所有工作区",
  "settings.workspaces.delete.warning": "工作区目录和分支将被永久移除，包括下方显示的所有未合并更改。",
  "settings.workspaces.deleteAll.warning": "具有未合并更改、关联会话或活动位置的工作树将被保留。",
  "settings.workspaces.delete.blocked.active": "无法删除活跃工作区。",
  "settings.workspaces.delete.blocked.linked": "关联的会话将保留，但其工作目录会被永久移除。",
  "settings.workspaces.default.title": "默认环境",
  "settings.workspaces.default.description": "选择新会话的启动位置",
  "settings.workspaces.default.lastUsed": "各项目上次使用的位置",
  "settings.workspaces.default.local": "本地目录",
  "settings.workspaces.default.new": "新建工作区",
  "workspace.onboarding.title": "使用工作区隔离会话",
  "workspace.onboarding.description": "每个会话都有独立的检出，因此不会干扰本地仓库",
  "session.summary.basedOn": "基于 {{branch}}",
  "desktop.menu.installCli": "安装 CLI...",
  "desktop.cli.installed.title": "CLI 已安装",
  "desktop.cli.installed.message": "CLI 已安装到 {{path}}\n\n请重启终端以使用“opencode2”命令。",
  "desktop.cli.failed.title": "安装失败",
  "desktop.cli.failed.message": "安装 CLI 失败：{{error}}",
  "command.project.copyID": "复制项目 ID",
  "command.session.copyID": "复制会话 ID",
  "server.row.incompatible": "此服务器正在运行 OpenCode {{version}}，与此应用不兼容。请升级到 OpenCode V2 以继续。",
  "toast.session.copyID.failed.title": "复制会话 ID 失败",
  "toast.session.copyID.failed.description": "复制会话 ID 时出错",
  "toast.project.copyID.failed.title": "复制项目 ID 失败",
  "toast.project.copyID.failed.description": "复制项目 ID 时出错",
  "error.page.title.status": "服务器请求失败",
  "error.page.description.status": "服务器返回了 HTTP {{status}} 响应。",
  "error.page.action.reload": "重新加载",
  "session.error.incompatible": "不支持此服务器版本",
  "session.error.incompatible.description":
    "{{server}} 正在运行 OpenCode {{version}}，与此应用不兼容。请将服务器升级到 OpenCode V2 以继续。",
  "session.background.moveInline": "按 {{keybind}} 将正在运行的任务移至后台",
  "settings.general.row.terminalPlacement.title": "终端位置",
  "settings.general.row.terminalPlacement.description": "选择会话中终端的打开位置",
  "settings.general.row.terminalPlacement.side": "侧边",
  "settings.general.row.terminalPlacement.bottom": "底部",
  "dialog.server.menu.hide": "从项目列表中隐藏",
  "dialog.server.menu.show": "在项目列表中显示",
  "session.queue.count.one": "{{count}} 个已排队",
  "session.queue.count.other": "{{count}} 个已排队",
  "session.queue.steer": "引导",
  "session.queue.send": "发送",
  "session.queue.steerTooltip": "发送但不中断",
  "session.queue.remove": "移除",
  "session.queue.reorder": "重新排列已排队的提示词",
  "session.new.worktree.creating": "正在创建 worktree",
  "settings.backToApp": "返回应用",
  "settings.appearance.row.tabs.title": "标签页",
  "settings.appearance.row.tabs.description": "选择会话标签页的排列方式",
  "settings.appearance.row.tabs.horizontal": "水平",
  "settings.appearance.row.tabs.vertical": "垂直",
  "settings.general.row.followUpBehavior.title": "后续消息行为",
  "settings.general.row.followUpBehavior.description":
    "选择将后续消息加入队列还是引导当前轮次。使用 {{keybind}} 切换。",
  "settings.general.row.followUpBehavior.queue": "加入队列",
  "settings.general.row.followUpBehavior.steer": "引导",
  "session.new.workspace.branch.search.placeholder": "搜索分支",
  "toast.migration.progress.clearingOldEvents": "正在清除旧事件",
  "toast.migration.progress.migratingSessions": "正在迁移会话",
  "session.new.workspace.existingLabel": "工作树",
  "desktop.onboarding.defaultProject": "默认项目",

  "home.projects.all": "所有项目",
  "session.view.select": "课次视图",
  "session.background.moveRunning": "移至背景",
  "session.timeline.working": "工作中",
  "session.websearch.title": "第三方网页搜索",
  "session.websearch.description": "选择搜索提供商代理用于搜索网页",
  "session.websearch.provider": "搜索提供商",
  "session.websearch.any": "任何",
  "session.websearch.disable": "不使用搜索",
  "session.websearch.enable": "启用",
  "session.websearch.loadFailed": "无法加载搜索提供程序。",
  "session.websearch.empty": "没有可用的搜索提供程序。",
  "session.websearch.failed": "无法保存您的选择。请重试。",
  "session.websearch.retry": "重试",
  "session.search.placeholder": "查找...",
  "session.search.noResults": "无匹配项",
  "titlebar.tabs": "标签页",
  "titlebar.channel.local": "本地",
  "titlebar.channel.dev": "开发",
  "titlebar.channel.beta": "测试版",
  "settings.tab.experimental": "实验",
  "settings.experimental.description": "尝试实验性功能",
  "settings.tab.about": "关于",
  "settings.about.version": "版本{{version}}",
  "settings.about.devVersion": "发展",
  "settings.about.license": "根据麻省理工学院许可证发布",
  "settings.about.otherContributor.one": "{{count}}其他",
  "settings.about.otherContributor.other": "其他{{count}}人",
  "settings.about.firstPublished": "首次在美国密苏里州发布",
  "settings.about.firstIllustrated": "首次在英国伦敦展出",
  "settings.about.website": "www.opencode.ai",
  "settings.about.description": "OpenCode ，开源编码代理",
  "settings.about.trademark": "OpenCode是Anomaly Innovations, Inc.的注册商标。",
  "settings.about.typeset": "Inter和IBM Plex Mono中的排版",
  "settings.about.tagline": "没有您，人工智能无法构建出色的软件",
  "settings.about.copyright": "© Anomaly Innovations, Inc.",
  "project.settings.title": "编辑项目",
  "settings.timeline.title": "时间表",
  "settings.timeline.detail": "时间轴详细信息",
  "settings.timeline.description": "选择时间轴上显示的活动量。消息始终可见。",
  "settings.timeline.preset.everything": "一切",
  "settings.timeline.preset.detailed": "详情",
  "settings.timeline.preset.compact": "紧凑型",
  "settings.timeline.preset.quiet": "安静",
  "settings.timeline.preset.text-only": "仅文本",
  "settings.timeline.description.everything": "单独显示所有活动。 展开shell输出、编辑和思考。",
  "settings.timeline.description.detailed": "展开shell输出和编辑。 单独显示子代理，并在已使用中对其他活动进行分组。",
  "settings.timeline.description.compact": "隐藏详细信息，将工具分组，并折叠思考内容。",
  "settings.timeline.description.quiet": "对已使用的编辑和子代理进行分组。隐藏其他活动。",
  "settings.timeline.description.text-only": "隐藏所有活动。仅显示消息。",
  "settings.timeline.description.custom": "为每个活动类别使用您选择的位置和详细信息。",
  "settings.timeline.custom": "自定义",
  "settings.timeline.advanced": "高级",
  "settings.timeline.advanced.description": "设置每个活动类别的位置和详细信息。",
  "settings.timeline.category.shell": "壳牌",
  "settings.timeline.category.edit": "编辑",
  "settings.timeline.category.thinking": "思考",
  "settings.timeline.category.subagents": "子代理",
  "settings.timeline.category.notices": "注意事项",
  "settings.timeline.category.tools": "其他工具",

  "provider.connect.error.unsupportedFields": "此身份验证表单包含不受支持的字段",
  "settings.about.writtenByNames": "作者：{{names}}",
  "settings.about.illustratedByNames": "插图由{{names}}",
  "server.action.authenticate": "验证",
  "server.status.connecting": "正在通过 SSH 连接…",
  "server.status.authentication": "需要身份验证",
  "common.color.orange": "橙色",
  "common.color.yellow": "黄色",
  "common.color.cyan": "青色",
  "common.color.green": "绿色",
  "common.color.red": "红色",
  "common.color.pink": "粉色",
  "common.color.blue": "蓝色",
  "common.color.purple": "紫色",
  "common.color.gray": "灰色",
  "mcp.auth.interactiveForm": "MCP 服务器 {{name}} 需要交互式身份验证表单",
  "server.connect.title": "连接到服务器",
  "server.connect.description": "输入您的服务器地址和密码以开始。",
  "server.connect.button": "连接",
  "server.connect.address.invalid": "请输入有效的 HTTP 或 HTTPS 服务器地址。",
  "server.connect.failed": "无法连接。请检查服务器地址和密码，然后重试。",
  "server.connect.scan": "扫描二维码",
  "server.connect.scan.description": "将摄像头对准 opencode pair 显示的二维码。",
  "server.connect.scan.invalid": "这不是 OpenCode 配对码。请扫描 opencode pair 显示的二维码。",
  "server.connect.camera": "正在配对摄像头",
  "server.connect.camera.starting": "正在打开摄像头…",
  "server.connect.mixedContent": "无法从 HTTPS 页面连接此 HTTP 服务器。请使用 HTTPS 服务器地址。",
  "server.connect.camera.unavailable": "此浏览器无法使用摄像头。请手动输入连接详情。",
  "server.connect.camera.error": "无法打开摄像头。请允许摄像头访问或手动输入连接详情。",
  "dialog.server.menu.remove": "移除",
  "toast.migration.progress.migratingSessions.current": "正在迁移会话 {{current}}",
  "toast.migration.progress.migratingSessions.progress": "正在迁移会话 {{current}}/{{total}}",
  "toast.migration.progress.working": "正在迁移数据",
  "toast.migration.progress.working.current": "正在迁移数据 {{current}}",
  "toast.migration.progress.working.progress": "正在迁移数据 {{current}}/{{total}}",
  "home.workspaceTip": "在新工作区中开始下一个会话以保持更改独立",
  "session.tab.add": "添加标签页",
  "session.queue.attachments.one": "添加 {{count}} 个附件",
  "session.queue.attachments.other": "添加 {{count}} 个附件",
  "settings.backToSettings": "返回设置",
  "settings.backToProjects": "返回项目",
  "settings.search.placeholder": "搜索",
  "settings.search.results": "设置结果",
  "settings.search.group.pages": "页面",
  "settings.search.group.settings": "设置",
  "settings.search.group.projects": "项目",
  "settings.search.group.servers": "服务器",
  "settings.search.result": "{{title}}，{{scope}}，{{page}}",
  "settings.search.page": "{{title}}，{{scope}}",
  "settings.search.result.unscoped": "{{title}}，{{page}}",
  "settings.search.empty": "未找到 {{query}} 的结果",
  "settings.search.refine": "缩小搜索范围以查看更多具体结果。",
  "settings.server.description": "管理此服务器的连接和偏好设置",
  "settings.server.section.connection": "连接",
  "settings.server.preferences.websearch.title": "第三方搜索",
  "settings.server.preferences.websearch.description": "选择代理用来在网络上搜索的搜索提供商",
  "settings.projects.search.placeholder": "搜索项目",
  "project.settings.name.title": "项目名称",
  "project.settings.name.description": "在 OpenCode 中此项目显示的名称",
  "project.settings.icon.description": "建议：128×128 像素。点击或拖动上传图片。",
  "project.settings.color.description": "当未设置自定义图片时用于项目图标",
  "project.settings.worktree.startup.description": "在创建新工作树后运行一次",
  "project.settings.worktree.startup.hint.base": "使用 $OPENCODE_WORKTREE_BASE 作为基础工作树。",
  "project.settings.worktree.startup.hint.new": "使用 $OPENCODE_WORKTREE_PATH 作为新工作树。",
  "project.settings.extensions.empty.mcps.title": "尚无 MCP",
  "project.settings.extensions.empty.mcps.description": "可用于 OpenCode 的 MCP 将显示在这里",
  "project.settings.extensions.empty.plugins.title": "尚无插件",
  "project.settings.extensions.empty.plugins.description": "可用于 OpenCode 的插件将显示在这里",
  "project.settings.extensions.empty.skills.title": "尚无技能",
  "project.settings.extensions.empty.skills.description": "可用于 OpenCode 的技能将显示在这里",
  "project.settings.extensions.lsp.configured": "已配置的语言服务器",
  "project.settings.extensions.lsp.status.enabled": "在配置中启用",
  "project.settings.extensions.lsp.status.disabled": "在配置中禁用",
  "project.settings.extensions.lsp.empty.title": "尚未配置语言服务器",
  "project.settings.extensions.lsp.empty.description": "为此项目配置的语言服务器将显示在这里",
  "project.settings.extensions.lsp.disabled.title": "语言服务器已禁用",
  "project.settings.extensions.lsp.disabled.description": "此项目配置中已禁用 LSP",
  "project.settings.extensions.lsp.loadFailed": "无法加载语言服务器配置",
  "project.settings.extensions.lsp.retry": "重试",
  "settings.timeline.summary": "{{preset}}：",
  "settings.timeline.group": "分组",
  "settings.timeline.collapse": "折叠",
  "settings.timeline.visibility.show": "显示",
  "settings.timeline.visibility.hide": "隐藏",
  "settings.timeline.visibility.label": "{{activity}} 可见性",
  "settings.timeline.grouped.label": "{{activity}} 已分组",
  "settings.timeline.collapsed.label": "{{activity}} 已折叠",
  "session.new.workspace.search.empty": "没有匹配的工作树",
  "settings.workspaces.description": "查看工作树并管理磁盘使用",
  "settings.workspaces.empty.description": "在 OpenCode 中创建的工作树将显示在此处",
  "settings.workspaces.sessions.filtered.one": "{{count}} 个会话",
  "settings.workspaces.sessions.filtered.other": "{{count}} 个会话",
  "settings.workspaces.deleteAll.confirm.one": "这将永久删除 {{count}} 个选定的工作树。",
  "settings.workspaces.deleteAll.confirm.other": "这将永久删除 {{count}} 个选定的工作树。",
  "settings.workspaces.deleteWithoutSessions": "删除没有会话的工作树",
  "settings.workspaces.deleteWithoutSessions.confirm.one": "这将永久删除 {{count}} 个没有关联会话的工作树。",
  "settings.workspaces.deleteWithoutSessions.confirm.other": "这将永久删除 {{count}} 个没有关联会话的工作树。",
  "settings.workspaces.deleteWithoutSessions.warning": "有未合并更改或活跃位置的工作树将被保留。",
  "settings.workspaces.delete.button": "删除工作树",
  "workspace.lifecycle.deleting": "正在删除…",
  "session.summary.mcp.prepareFailed": "无法准备 MCP 服务器",
  "session.summary.mcp.unavailable": "MCP 服务器 {{name}} 在此工作树中不可用。",
  "session.summary.mcp.signInBeforeSend": "在发送提示之前，请先登录 {{name}}。",
  "session.summary.mcp.notReady": "MCP 服务器 {{name}} 尚未准备好。在发送提示前请先解决其连接问题。",
  "workspace.delete.confirm": "删除“{{name}}”吗？",
  "workspace.delete.location": "位置",
  "settings.search.empty.query": "“{{query}}”",
} satisfies Partial<Record<Keys, string>>

export default dict
